export const isCloudEnv = () => !!window.parent.primingcloud
export const isDevEnv = () => process.env.NODE_ENV === "development"
export const isProdEnv = () => process.env.NODE_ENV === "production"
